module.exports = __webpack_public_path__ + "img/msg-notice.120173d3.png";